import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    trackingNumbers:"",//初始化跟踪号
  },
  mutations: {
    setTrackingNumbers(state,data){
      state.trackingNumbers=data;
    }
  },
  actions: {

  },
  computed: {
  },
  watch: {
  }
})
